import fetchAPI from '../fetchAPI';

interface CallUpdateBillProps {
  id: string;
  status?: 'unpaid' | 'in_progress' | 'paid' | 'overdue' | 'void';
  notes?: string | null;
}

export const callUpdateBill = async (
  { id, ...body }: CallUpdateBillProps
): Promise<iResponse<Bill>> => {
  const response: iResponse<Bill> = await fetchAPI({
    method: `PATCH`,
    route: `bills/${id}`,
    data: body
  });

  return response;
};

export default callUpdateBill;
